module.exports = __webpack_public_path__ + "img/Premiere.fb4744f0.png";